app.controller("ExamsManagerHallsController", [
    "$scope", "ExamsManagerService", "$stateParams", "$state", "$uibModal", "toastr", "ConfirmModal",
    function ($scope, ExamsManagerService, $stateParams, $state, $uibModal, toastr, ConfirmModal) {

        $scope.resetForm = function () {
            $scope.name = "";
            $scope.count = 0;
            $scope.ordered = false;
            $scope.withComputers = false;
        };

        $scope.fetchHalls = function () {
            ExamsManagerService.fetchExamHalls().then(function (data) {
                $scope.examHalls = data;
                $scope.totalItems = data.length;
                console.log(data);
            });
        };

        $scope.resetForm();
        $scope.fetchHalls();

        $scope.add = function () {
            // return console.log({
            //     name: $scope.name,
            //     count: $scope.count,
            //     ordered: $scope.ordered,
            //     withComputers: $scope.withComputers
            // });
            ExamsManagerService.addExamHall({
                name: $scope.name,
                seatCount: $scope.count,
                ordered: $scope.ordered,
                withComputers: $scope.withComputers
            }).then(function () {
                $scope.resetForm();
                $scope.fetchHalls();
                toastr.success('', 'ოთახი წარმატებით დაემატა');
            });
        };

        $scope.edit = function (examHall) {
            $uibModal.open({
                controller: "ExamsManagerEditHallController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-edit-hall.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {examHall: examHall};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.fetchHalls();
                }, function () {
                });
        };

        $scope.remove = function (examHall) {
            console.log(examHall);
            ConfirmModal.show({
                title: "ოთახის წაშლა",
                message: "ყურადღება! ნამდვილად გსურთ ოთახის წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeExamHall({
                    examHallId: examHall._id
                }).then(function () {
                    toastr.success('', 'ოთახი წარმატებით წაიშალა სიიდან');
                    $scope.fetchHalls();
                });
            });
        };
    }
]);